module.exports = __webpack_public_path__ + "img/tick_tickhover.cb191e73.png";